import { render } from "./price_show.vue?vue&type=template&id=5e31d972&scoped=true"
import script from "./price_show.vue?vue&type=script&lang=js"
export * from "./price_show.vue?vue&type=script&lang=js"

import "./price_show.vue?vue&type=style&index=0&id=5e31d972&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e31d972"]])

export default __exports__